
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/summary",
      function () {
        return require("private-next-pages/order/summary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/summary"])
      });
    }
  